import { useState } from 'react';
import { ArrowLeft, ArrowRight, LoaderCircle, Mail, TriangleAlert } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useNotification } from '../../../components/Notifications/NotificationContext';
import { useAuth } from '../../../context/AuthProvider';
import AuthShell from '../AuthShell.jsx';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sentTo, setSentTo] = useState(null);
  const [loading, setLoading] = useState(false);

  const { showError } = useNotification();
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      // Resposta sempre genérica: não revela se o email tem conta.
      setSentTo(email);
      setEmail('');
    } catch (err) {
      showError(err.response?.data?.error || 'Erro ao enviar solicitação.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={
        <>
          Recupere o <span className="sp-gradient-text">acesso.</span>
        </>
      }
    >
      <h2 className="sp-card-title">Recuperar senha</h2>

      {sentTo ? (
        <>
          <p className="sp-card-sub">
            Se existir uma conta com <strong>{sentTo}</strong>, enviamos um link para criar
            uma nova senha. Ele vale por 1 hora.
          </p>
          <div className="sp-verify-hint" style={{ marginTop: '1.5rem' }}>
            <TriangleAlert size={16} aria-hidden="true" />
            <span>Não chegou? Confira a caixa de <strong>SPAM</strong> antes de pedir de novo.</span>
          </div>
          <button type="button" className="sp-btn-primary" onClick={() => setSentTo(null)}>
            Enviar para outro email
          </button>
        </>
      ) : (
        <>
          <p className="sp-card-sub">
            Informe o email da sua conta e mandamos um link para criar uma nova senha.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="sp-field">
              <label htmlFor="email" className="sp-label">Email</label>
              <div className="sp-input-wrapper">
                <Mail className="sp-input-icon" size={16} aria-hidden="true" />
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                  autoComplete="email"
                  placeholder="seu@email.com"
                  disabled={loading}
                  className="sp-input"
                />
              </div>
            </div>

            <button type="submit" className="sp-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <LoaderCircle className="sp-spin" size={18} aria-hidden="true" />
                  Enviando...
                </>
              ) : (
                <>
                  Enviar link
                  <ArrowRight className="sp-btn-arrow" size={18} aria-hidden="true" />
                </>
              )}
            </button>
          </form>
        </>
      )}

      <div className="sp-card-footer">
        <Link to="/login" className="sp-link sp-back-link">
          <ArrowLeft size={16} aria-hidden="true" /> Voltar para o login
        </Link>
      </div>
    </AuthShell>
  );
}
